import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { Row, Col, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { isEmpty } from "lodash";
import APIClient from '../../../helpers/APIClient';
import Loader from '../../../components/Loader';
import { baseUrl } from '../../../constants/environment';
import styled from 'styled-components';
import ProductInfo from './ProductInfo';
import ProductStockFirst from './ProductStockFirst';
import ProductUnit from './ProductUnit';
import ProductAattributes from './ProductAattributes';
import ProductPrice from './ProductPrice';
import ProductStock from './ProductStock';
import ProductExpiration from './ProductExpiration';
import ProductImages from './ProductImages';
import ProductVarriant from './ProductVarriant';
import ProductViewInfo from './ProductViewInfo';
import ProductViewDetail from './ProductViewDetail';
import ProductViewVariant from './ProductViewVariant';
import ProductViewStock from './ProductViewStock';

const ProductContentPageDetail = (props: any) => {
    const {
        data, type, setData, category, brand, origin, onlyView, id, imgs, setImgs, action, handleActionModal,
        branch, stock, setStock, unit, attributes, setAttributes, setUnit, handleChangeInput, varriant
    } = props
    
    const [loading, setLoading] = useState(false)

    const router = useHistory()

    return (
        <PageContent className={onlyView ? 'only-view' : ''}>
            <Row>
                <Col md={12}>
                    <ProductViewInfo {...props} handleChangeInput={handleChangeInput} />
                </Col>
                {varriant?.length === 0 ?
                    <>
                        <Col md={12} className="varriant-tree-view">
                            <ProductViewDetail {...props} handleChangeInput={handleChangeInput} />
                        </Col>
                    </>:
                    <>
                        <Col md={4} className="varriant-tree-view">
                            <ProductViewVariant {...props} handleChangeInput={handleChangeInput} />
                        </Col>
                        <Col md={8} className="varriant-tree-view">
                            <ProductViewDetail title="Thông tin chi tiết phiên bản" {...props} handleChangeInput={handleChangeInput} />
                        </Col>
                    </>
                }
                <Col md={12}>
                    {/* kho */}
                    <ProductViewStock {...props} handleChangeInput={handleChangeInput} />
                </Col>
            </Row>
            <div className="bottom-action">
                <Button color="success" className='success-bland ml-2' onClick={() => router?.goBack()}>Đóng</Button>
                <Button color="danger" className='danger-bland ml-2' onClick={() => props?.handleActionModal({ data: data, type: 'delete' })}>Xóa sản phẩm</Button>
                <Button color="success" className='ml-2' onClick={() => router?.push(`/product/${id}`)}>Chỉnh sửa</Button>
            </div>
            {loading && <Loader />}
        </PageContent>
    )
}

export const PageContent = styled.div`
    padding-bottom: 60px;
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

export default ProductContentPageDetail